import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import {
  StyledDropdownMenu,
  StyledDropdownToggle,
} from '../../../components/Reusable/StandardDropdown/StandardDropdown.styles'
import { MenuPlaceholder } from '../../../components/Placeholders/MenuPlaceholder'
import { ModalFormId } from '../../../components/ModalForms/ModalForm'
import { AuditsDropdownMenu } from './AuditsDropdown.components'
import { AuditsDropdownContainer } from './AuditsDropdown.styles'

export const AuditsDropdown = ({
  audits,
  selectedItem,
  onAuditSelected,
  allowClear,
}: {
  audits: AuditRecord[]
  selectedItem: string
  onAuditSelected: (audit?: AuditRecord) => React.MouseEventHandler<HTMLElement>
  allowClear?: boolean
}): JSX.Element =>
  !audits ? (
    <Dropdown.Menu as={StyledDropdownMenu}>
      <MenuPlaceholder height={96} />
    </Dropdown.Menu>
  ) : (
    <Dropdown id={ModalFormId.RUN_AUDITBOT} drop="down">
      <Dropdown.Toggle as={StyledDropdownToggle} width="100%">
        {selectedItem}
      </Dropdown.Toggle>
      <AuditsDropdownContainer>
        <AuditsDropdownMenu
          allowClear={allowClear}
          auditsList={audits}
          onAuditSelected={onAuditSelected}
        />
      </AuditsDropdownContainer>
    </Dropdown>
  )
